
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"37","height":"37","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M4.713 10.05a2 2 0 00-1.861 1.835L1.207 32.297a3 3 0 002.99 3.241h9.776v.012H25.32a3 3 0 003-3V22.418h-4.57a2.967 2.967 0 11-4.834 0H14.81l-.058-4.62a2.967 2.967 0 10-.058-4.56l-.049-3.847-9.932.659z","fill":"#CFD8DC"}}),_c('path',{attrs:{"d":"M21.16 5.42l7.613-3.43a3 3 0 014.077 1.783l3.208 9.592-4.693 1.275a2.714 2.714 0 11-3.875 1.053l-4.367 1.187-.809-4.722a2.714 2.714 0 10-.788-4.6L21.16 5.42z","fill":"#85C4EE"}}),_c('path',{attrs:{"d":"M16.655 12.887a2.595 2.595 0 00-2.005.948V8.8H3.988a2.704 2.704 0 00-2.704 2.725v10.662h4.95a2.61 2.61 0 113.47 0h4.946V17.12a2.593 2.593 0 004.593-1.799 2.591 2.591 0 00-2.587-2.434zM6.233 22.187H1.284v10.662a2.701 2.701 0 002.704 2.701H14.65v-4.946a2.612 2.612 0 110-3.471v-4.946H9.704M14.65 30.592v4.946h10.662a2.7 2.7 0 002.704-2.689V22.187h-4.945a2.613 2.613 0 11-3.472 0H14.65v4.934M32.835 3.087a2.704 2.704 0 00-3.338-1.845L19.253 4.204l1.36 4.75a2.61 2.61 0 11.962 3.335l1.377 4.754L27.59 15.7a2.648 2.648 0 103.578-1.03l4.626-1.336-2.959-10.248z","stroke":"#455A64","stroke-width":"1.3","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    